import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { useEffect, useMemo } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AgentDetails from '../components/dashboard/ServerMonitoring/AgentDetails';
import * as dashboardActions from '../redux/actions/dashboardActions';

const isLikelyIpv4 = (value) => {
  if (typeof value !== 'string') return false;
  return /^\d{1,3}(\.\d{1,3}){3}$/.test(value);
};

const AgentDetailPageContainer = ({ 
  dashboard, 
  actions,
  userId
}) => {
  const { agentKey } = useParams();
  const history = useHistory();

  const overviewAgents = dashboard?.overview?.agents?.agents || [];

  const resolvedAgentIp = useMemo(() => {
    if (!agentKey) return null;
    const decoded = decodeURIComponent(agentKey);
    if (isLikelyIpv4(decoded)) return decoded;

    // Prefer stable identifiers in URL: instanceId (e.g., i-0123abcd...)
    const byInstanceId = overviewAgents.find((a) => a?.instanceId === decoded);
    if (byInstanceId?.ip) return byInstanceId.ip;

    return null;
  }, [agentKey, overviewAgents]);

  // Ensure we have an overview list to resolve instanceId -> ip (supports deep links).
  useEffect(() => {
    const hasAgents = Array.isArray(overviewAgents) && overviewAgents.length > 0;
    if (!hasAgents && userId) {
      actions.fetchDashboardOverview({ userId });
    }
  }, [overviewAgents, userId, actions]);

  // Fetch agent details
  useEffect(() => {
    if (resolvedAgentIp && userId) {
      actions.fetchAgentDetails({ agentIp: resolvedAgentIp, userId });
    }
  }, [resolvedAgentIp, userId, actions]);
  
  const handleBack = () => {
    history.push('/dashboard');
  };
  
  const overviewAgent = overviewAgents.find((agent) => agent?.ip === resolvedAgentIp);

  return (
    <AgentDetails
      agentData={dashboard.selectedAgent}
      loading={!dashboard.selectedAgent}
      onBack={handleBack}
      userId={userId}
      idleDiagnostics={overviewAgent?.idleDiagnostics}
    />
  );
};

const mapStateToProps = (state) => ({
  dashboard: state.dashboard,
  userId: state.catalogReducer?.user?.userId
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(dashboardActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgentDetailPageContainer);

